import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreUsersMfaModule,
  DatastoreUsersSelfModule,
} from '@freelancer/datastore/collections';
import { UiModule } from '@freelancer/ui';
import { TwoFactorAuthSectionComponent } from './two-factor-auth-section.component';
import { TwoFactorAuthSecurePhoneErrorComponent } from './two-factor-auth-secure-phone/two-factor-auth-secure-phone-error.component';

@NgModule({
  imports: [
    CommonModule,
    UiModule,
    DatastoreUsersMfaModule,
    DatastoreUsersSelfModule,
  ],
  declarations: [
    TwoFactorAuthSectionComponent,
    TwoFactorAuthSecurePhoneErrorComponent,
  ],
  exports: [
    TwoFactorAuthSectionComponent,
    TwoFactorAuthSecurePhoneErrorComponent,
  ],
})
export class TwoFactorAuthSectionModule {}
